import ICONS from 'components/base/featherIcons';
import { SVGProps } from 'react';

/**
 * A Feather icon by name - feather-icons-react's component and markup,
 * with only the icons the app uses bundled (featherIcons.ts, generated by
 * scripts/feather-subset.mjs; rerun it after using a new icon).
 */
const FeatherIcon = ({
  icon,
  size = 24,
  className = '',
  fill = 'none',
  strokeWidth = 2,
  ...rest
}: Omit<SVGProps<SVGSVGElement>, 'fill'> & {
  icon: string;
  size?: number | string;
  fill?: string;
  strokeWidth?: number | string;
}) => {
  if (!icon) return null;
  const markup = ICONS[icon];
  if (!markup && import.meta.env.DEV)
    console.warn(
      `FeatherIcon: "${icon}" isn't in featherIcons.ts - run scripts/feather-subset.mjs`
    );
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`feather feather-${icon} ${className}`}
      {...rest}
    >
      {markup && <g dangerouslySetInnerHTML={{ __html: markup }} />}
    </svg>
  );
};

export default FeatherIcon;
